// extracted by mini-css-extract-plugin
export default {"loginPage":"auth_loginPage__DTc0T","loginPage_content":"auth_loginPage_content__kS73S","form":"auth_form__FIMlt","form_item":"auth_form_item__tCvYQ"};